import { render, staticRenderFns } from "./TableEntity.vue?vue&type=template&id=f83f9fd2"
import script from "./TableEntity.vue?vue&type=script&lang=js"
export * from "./TableEntity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports